// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.
import { AppShellComponentType } from '@priva/appshell';

export const environment = {
    production: true,
    sourceMap: false,
    optimization: false,
    debugState: false,
    offline: false,

    configuration: {
        appVersion: '20251024.1',
        name: 'Performance Activity',
        showUserName: false,
        showTenantName: false,
        uris: {
            apiService: '/v1',
            preferenceApi: '/api/v1/preferences',
            consolidatedPreferences: '/api/v1/preferences',
        },
        analytics: {
            segment: {
                apiKey: '0cecWrRxvUarRnAh43EJN2MB9MyJyXP0',
            },
            appInsights: {
                instrumentationKey: '',
            },
        },
        features: [
            { name: 'brand2025', state: true },
            {
                name: 'appshell.header.all-components-enabled',
                state: true,
            },
        ],
        components: {
            appSettings: {
                type: AppShellComponentType.AppSettings,
                behavior: 'link',
                pageUri: '/settings',
            },
            appHelp: {
                behavior: 'service',
                serviceUri: '',
            },
            userInfo: {
                behavior: 'service',
            },
        },
    },

    version: '0.1.0',
    buildDate: Date.now(),
};
